import { useEffect, useRef, useState } from 'react';
import { qaItems } from '../data/qa';

export function QuickQA() {
  const [open, setOpen] = useState(false);
  const closeButtonRef = useRef<HTMLButtonElement | null>(null);

  useEffect(() => {
    if (open) {
      closeButtonRef.current?.focus();
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }

    return () => {
      document.body.style.overflow = '';
    };
  }, [open]);

  useEffect(() => {
    const handler = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        setOpen(false);
      }
    };
    if (open) {
      window.addEventListener('keydown', handler);
    }
    return () => window.removeEventListener('keydown', handler);
  }, [open]);

  return (
    <div className="qa">
      <button className="qa__fab" type="button" onClick={() => setOpen(true)}>
        Ask Varun
      </button>
      {open ? (
        <div className="qa__overlay" role="dialog" aria-modal="true" aria-label="Quick Q&A">
          <div className="qa__panel">
            <div className="qa__header">
              <div>
                <p className="qa__eyebrow">Quick Q&amp;A</p>
                <h3 className="qa__title">Recruiter-friendly highlights</h3>
              </div>
              <button
                className="qa__close"
                type="button"
                onClick={() => setOpen(false)}
                ref={closeButtonRef}
              >
                Close
              </button>
            </div>
            <div className="qa__list">
              {qaItems.map((item, index) => (
                <div key={`${item.question}-${index}`} className="qa__item">
                  <p className="qa__question">{item.question}</p>
                  <p className="qa__answer">{item.answer}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
}
